import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import Moment from "react-moment";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import CreatePOMasterModal from "../../../../Components/Modal/supplier_app/PO_Collabration/CreatePOMasterModal";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { useNavigate } from "react-router-dom";
import {
  addPoDetailNumber,
  getPurchaseOrder,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import configFromEnv from "../../../../services/configuration";
import { currencyFormat, formatDate } from "../../../../common/Validations";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CancelModal from "../../../../Components/Modal/supplier_app/common/CancelModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
// import PoModal from "./PoExtractModal";
import PoExtractModal from "./PoExtractModal";

const PurchaseOrderExtractList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "SAP Order");

  let userData = useSelector((state) => state?.user); // User Details from Store
  let purchaseOrderData = useSelector(
    (state) => state?.purchasing?.purchase_order
  ); // get purchaseOrderData from Store

  let purchaseOrderTable = useSelector(
    (state) => state?.purchasing?.purchase_order?.pagination
  ); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.purchaseOrder); // config Details from Store
  let module = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.PO?.module
  ); // config Details from Store

  const [data, setData] = useState([]);

  const [getNewPerPage, setNewPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [getPurchaseDocType, setPurchaseDocType] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [getShowPoModal, setShowPoModal] = useState(false);

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const detailedPage = (poNumber) => {
    // console.log("poNumber", poNumber);
    dispatch(addPoDetailNumber(poNumber));
    navigate(Constants.SAP_PURCHASE_ORDER_DETAIL_PAGE);
  };
  const loadInitialPOData = async () => {
    setData(purchaseOrderData?.data);
  };

  useEffect(() => {
    loadInitialPOData(); // fetch page 1 of users

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseOrderData]);

  //on page load
  useEffect(() => {
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span>
            <i className="bi bi-git iconTable"></i>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Document Type",
      // selector: (row) => row.purchasingDocumentCode,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {/* {row.purchasingDocumentType} */} NB{" "}
          </p>
        </div>
      ),
    },
    {
      name: "SAP PO Nr",
      selector: (row) => row.purchasingDocumentNr || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {row.purchasingDocumentNr}{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Document",
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      width: "150px",
    },
    // Conditionally include the 'workflowActionLogs' column
    // ...(data?.some((row) => row.workflowActionLogs !== undefined)
    //   ? [
    //       {
    //         name: "Workflow log",
    //         selector: (row) => row.workflowActionLogs,
    //         cell: (row) => (
    //           <div
    //             style={{ width: "100%" }}
    //             className="d-flex justify-content-center iconTable"
    //           >
    //             <img
    //               src="assets/img/newIcons/workflow.png"
    //               alt="attachments"
    //               style={{ width: "35px" }}
    //               className="mt-1"
    //               onClick={() => showStatusInfo(row.workflowActionLogs)}
    //             />
    //           </div>
    //         ),
    //         sortable: true,
    //         width: "132px",
    //       },
    //     ]
    //   : []),
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.item)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.item?.length} </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "Attachments",
      selector: (row) => row.attachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center"
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    // {
    //   name: "Version",
    //   selector: (row) => row.version || "--",
    //   sortable: true,
    //   width: "100px",
    // },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={"New"} />
        </>
      ),
      selector: (row) => row.statusHeader || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Date",
      selector: (row) => formatDate(row?.purchaseDocumentDate) || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "PO Value",
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold text-nowrap">
          INR {currencyFormat(Number(row.totalNetValue))}
        </span>
      ),
      selector: (row) => row.purchasingDocumentValue || "--",
      sortable: true,
      width: "130px",
    },
    // {
    //   name: "Currency ",
    //   cell: (row) => (
    //     <>
    //       <span className="m-0 p-0 pt-1 fw-bold">{row.currency}</span>
    //     </>
    //   ),
    //   selector: (row) => row.currency || "--",
    //   sortable: true,
    //   width: "110px",
    // },
    {
      name: "Supplier",
      selector: (row) => row.vendorNumber,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorNumber} </p>
          {/* <p className="m-0 p-0">{row.vendorName} </p> */}
        </div>
      ),
    },
    // {
    //   name: "Payment Terms",
    //   cell: (row) => <>{row.paymentTerms}</>,
    //   selector: (row) => row.paymentTerms,
    //   sortable: true,
    //   width: "180px",
    // },
    // {
    //   name: "Inco Terms",
    //   selector: (row) => row.incoTerms,
    //   sortable: true,
    //   width: "180px",
    // },
    // {
    //   name: "Payment Terms",
    //   selector: (row) => row.paymentTermsCode,
    //   sortable: true,
    //   width: "150px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{row.paymentTerms} </p>
    //     </div>
    //   ),
    // },
    // {
    //   name: "Inco Terms",
    //   selector: (row) => row.incoTermsCode,
    //   sortable: true,
    //   width: "150px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 ">{row.incoTerms} </p>
    //     </div>
    //   ),
    // },
    {
      name: "Created Date",
      selector: (row) => formatDate(row.createdAt),
      cell: (row) => (
        <Moment format={configFromEnv.TIME_FORMATE_WITH_TIME}>
          {row.createdAt}
        </Moment>
      ),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Company",
    //   cell: (row) => (
    //     <>
    //       <span> {row.companyCodeDesc} </span>
    //     </>
    //   ),
    //   width: "150px",
    // },
    {
      name: "Purchase Group",
      cell: (row) => (
        <>
          <span> {row.purchaseDocumentGroup} </span>
        </>
      ),
      width: "150px",
    },
    // {
    //   name: "PR Number",
    //   selector: (row) => row.item?.requestNumber || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "RFQ",
    //   cell: (row) => (
    //     <button className="btnInfo">{row.rfxCollectiveNr || "--"} </button>
    //   ),
    //   width: "150px",
    // },
    // {
    //   name: "Quotation",
    //   cell: (row) => (
    //     <button className="btnInfo">{row.quotationNumber || "--"}</button>
    //   ),
    //   width: "150px",
    // },

    // {
    //   name: "Qtn Version",
    //   selector: (row) => row.rfqTechFocalPerson,
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "Delivery Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.deliveredStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
    // {
    //   name: "Invoice Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.invoicedStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
    // {
    //   name: "Payment Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.paymentStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
  ];

  const lineItemColInfo = [
    {
      name: "Item Nr",
      cell: (row) => <span>{row.purchaseDocumentItem} </span>,
      width: "180px",
    },
    // {
    //   name: "Schedule Nr",
    //   cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
    //   width: "180px",
    // },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.material} </p>
          <p className="m-0 p-0">{row.briefDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.businessLocation} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQty} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.netPrice} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnit} </span>,
      width: "220px",
    },
    {
      name: "Net Value",
      cell: (row) => <span>{row.netValue} </span>,
      width: "220px",
    },
    // {
    //   name: "Delivery Date",
    //   cell: (row) => <span>{row.deliveryDate} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Purchase Req.",
    //   cell: (row) => <span>{row.requestNumber} </span>,
    //   width: "220px",
    // },
    {
      name: "Tax Id",
      cell: (row) => <span>{row.taxId} </span>,
      width: "220px",
    },
    {
      name: "Storage Place",
      cell: (row) => <span>{row.storagePlace} </span>,
      width: "220px",
    },
  ];

  const getMasterData = async () => {
    let obj = {
      codeType: "PurchaseDocType",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setPurchaseDocType(item?.data);
      } else {
        setPurchaseDocType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  useEffect(() => {
    if (data.length === 0) return;

    const updatedData = data.map((obj) => {
      const totalNetValue = obj.item?.reduce((sum, curr) => {
        return sum + parseFloat(curr.netValue?.trim() || 0);
      }, 0);

      return {
        ...obj,
        totalNetValue: totalNetValue,
      };
    });

    setData(updatedData);
  }, [data]);

  const handlePageChange = (page) => {
    let obj = {
      page: page,
      per_page: getNewPerPage,
      vendorCode: userData?.data?.userId,
      role: userData?.data?.roles?.length > 0 ? userData?.data?.roles[0] : "",
      searchTerm: getCommonSearchTxt,
    };

    dispatch(getPurchaseOrder(obj));
    setData(purchaseOrderData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      page: page,
      per_page: newPerPage,
      vendorCode: userData?.data?.userId,
      role: userData?.data?.roles?.length > 0 ? userData?.data?.roles[0] : "",
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getPurchaseOrder(obj));
    setData(purchaseOrderData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      module: "PO",
      queryName: "getSAPPO",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getPurchaseOrder(obj));
  };

  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = () => {
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.statusHeader !== "Cancelled"
    );
    setSelectedRows(validRows);
  };

  const hidePoModal = () => setShowPoModal(false);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle"> SAP Purchase Order</h2>
                <p className="subText">
                  Lists of SAP Purchase Order and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>

            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MT</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">SAP PO List</span>
                      <span className="subHeaderTitle">
                        View of SAP PO and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable"
                          onClick={() => setShowPoModal(true)}
                        >
                          Extract PO
                        </button>
                      </Col>                 
           
                      {config?.deletion && (
                        <Col xs={3} md={3} lg={3} className="">
                          <button
                            className="btnTable"
                            onClick={cancelModalShow}
                            disabled={getSelectedRows.length > 0 ? false : true}
                          >
                            <i className="bi bi-x-circle"></i> Cancel
                          </button>
                        </Col>
                      )}

                      {config?.filter && (
                        <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={purchaseOrderTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreatePOMasterModal
        show={modalShow}
        onHide={() => hideModal()}
        dropdowndata={getPurchaseDocType}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
    
      <CancelModal
        title="Cancel the Purchase Order"
        type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
      <PoExtractModal
        show={getShowPoModal}
        onHide={hidePoModal}
        // onSubmit={inviteSupplier}
        data={getSelectedRows}
      />
    </main>
  );
};

export default PurchaseOrderExtractList;
